import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

type MessageCallback = (event: MessageEvent) => void;
type ErrorCallback = (event: Event) => void;

interface UseWebSocketOptions {
  onMessage?: MessageCallback;
  onError?: ErrorCallback;
}

function useWebSocket(url: string, options: UseWebSocketOptions = {}) {
  const [socket, setSocket] = useState<WebSocket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  // 使用 useCallback 缓存回调函数
  const onMessageCallback = useCallback(
    (event: MessageEvent) => {
      if (options.onMessage) {
        options.onMessage(event);
      }
    },
    [options.onMessage]
  );

  const onErrorCallback = useCallback(
    (event: Event) => {
      if (options.onError) {
        options.onError(event);
      }
    },
    [options.onError]
  );

  useEffect(() => {
    let ws: WebSocket | null = new WebSocket(url);

    ws.onopen = (event) => {
      setIsConnected(true);
    };

    ws.onmessage = onMessageCallback;

    ws.onerror = onErrorCallback;

    ws.onclose = () => {
      setIsConnected(false);
    };

    setSocket(ws);

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [url]);

  return { socket, isConnected };
}

export default useWebSocket;
